export default __webpack_public_path__ + "229be7d13220918493c823c2f10eb998.png";